/* Hygiene Hub Crew portal actions \u2014 /pages/crew (rebuild, 9 Sep 2026). Increment 2.
   Confirm sheets, toast, and the native mutating actions. Loads after hh-crew.js.
   Every action: confirm sheet \u2192 PUT (Appstle App Proxy) \u2192 re-fetch \u2192 re-render \u2192 toast.
   Cancel routes into Appstle's own save flow (never rebuilt here). */
(function () {
  var CTX = window.HHCrew; if (!CTX) return;
  var el = CTX.el, esc = CTX.esc, money = CTX.money, putAPI = CTX.putAPI, refresh = CTX.refresh,
    fmtDate = CTX.fmtDate, fmtLong = CTX.fmtLong, shiftISO = CTX.shiftISO, dateToISO = CTX.dateToISO,
    ymd = CTX.ymd, paymentLabel = CTX.paymentLabel, nextOrder = CTX.nextOrder, cid = CTX.cid,
    STATE = CTX.STATE, CFG = CTX.CFG;

  /* ---- confirm sheet ---- */
  var sheetEl = null;
  function closeSheet() { if (sheetEl) { sheetEl.remove(); sheetEl = null; document.removeEventListener('keydown', onEsc); } }
  function onEsc(e) { if (e.key === 'Escape') closeSheet(); }
  function openSheet(opts) {
    closeSheet();
    sheetEl = el('div', 'hhx-sheet-wrap');
    var sheet = el('div', 'hhx-sheet');
    sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML = '<div class="hhx-sheet-grab"></div>' +
      '<h3 class="hhx-sheet-t">' + esc(opts.title) + '</h3>' +
      '<div class="hhx-sheet-b">' + (opts.body || '') + '</div>' +
      '<div class="hhx-sheet-err" hidden></div>' +
      '<div class="hhx-sheet-actions">' +
      '<button type="button" class="hhx-btn hhx-btn--ghost hhx-sheet-x">' + esc(opts.cancelLabel || 'Not now') + '</button>' +
      '<button type="button" class="hhx-btn ' + (opts.confirmClass || 'hhx-btn--green') + ' hhx-sheet-go">' + esc(opts.confirmLabel || 'Confirm') + '</button>' +
      '</div>';
    sheetEl.appendChild(sheet);
    document.body.appendChild(sheetEl);
    document.addEventListener('keydown', onEsc);
    sheetEl.addEventListener('click', function (e) { if (e.target === sheetEl) closeSheet(); });
    sheet.querySelector('.hhx-sheet-x').addEventListener('click', closeSheet);
    var go = sheet.querySelector('.hhx-sheet-go');
    var errBox = sheet.querySelector('.hhx-sheet-err');
    if (opts.onMount) opts.onMount(sheet, go);
    go.addEventListener('click', function () {
      if (STATE.busy) return;
      errBox.hidden = true;
      var payload;
      try { payload = opts.collect ? opts.collect(sheet) : null; } catch (e) { errBox.textContent = e.message || 'Please choose an option.'; errBox.hidden = false; return; }
      if (payload === false) { errBox.textContent = 'Please choose an option.'; errBox.hidden = false; return; }
      STATE.busy = true; go.classList.add('is-loading'); go.disabled = true;
      Promise.resolve(opts.run(payload)).then(function () { return refresh(); }).then(function () {
        STATE.busy = false; closeSheet(); toast(opts.success || 'Done.');
      }).catch(function () {
        STATE.busy = false; go.classList.remove('is-loading'); go.disabled = false;
        errBox.textContent = 'That didn\u2019t go through. Please try again in a moment.'; errBox.hidden = false;
      });
    });
  }

  /* ---- toast ---- */
  var toastEl = null, toastT = 0;
  function toast(msg) {
    if (!toastEl) { toastEl = el('div', 'hhx-toast'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---- actions ---- */
  function doDelay() {
    var no = nextOrder(); if (!no) return;
    var body = '<p class="hhx-sheet-p">Push your ' + esc(fmtDate(no.billingDate)) + ' box back. Everything after it moves with it.</p>' +
      '<div class="hhx-choices">' +
      '<label class="hhx-choice"><input type="radio" name="dl" value="7" checked><span>1 week \u2014 ' + esc(fmtDate(shiftISO(no.billingDate, 7))) + '</span></label>' +
      '<label class="hhx-choice"><input type="radio" name="dl" value="14"><span>2 weeks \u2014 ' + esc(fmtDate(shiftISO(no.billingDate, 14))) + '</span></label>' +
      '<label class="hhx-choice"><input type="radio" name="dl" value="date"><span>Pick a date</span></label></div>' +
      '<input type="date" class="hhx-date-in" hidden min="' + esc(ymd(shiftISO(new Date().toISOString(), 1))) + '" value="' + esc(ymd(shiftISO(no.billingDate, 7))) + '">';
    openSheet({
      title: 'Delay your next box', body: body, confirmLabel: 'Delay box',
      onMount: function (sheet) {
        var di = sheet.querySelector('.hhx-date-in');
        sheet.querySelectorAll('input[name="dl"]').forEach(function (r) {
          r.addEventListener('change', function () { di.hidden = sheet.querySelector('input[name="dl"]:checked').value !== 'date'; });
        });
      },
      collect: function (sheet) {
        var v = sheet.querySelector('input[name="dl"]:checked').value; var iso;
        if (v === 'date') { var dv = sheet.querySelector('.hhx-date-in').value; if (!dv) return false; iso = dateToISO(dv, no.billingDate); }
        else iso = shiftISO(no.billingDate, parseInt(v, 10));
        return iso;
      },
      run: function (iso) { return putAPI('subscription-billing-attempts/reschedule-order/' + no.id + '?billingDate=' + encodeURIComponent(iso) + '&rescheduleFutureOrder=true'); },
      success: 'Next box delayed.'
    });
  }
  function doSkip() {
    var no = nextOrder(); if (!no) return;
    openSheet({
      title: 'Skip this box?',
      body: '<p class="hhx-sheet-p">You won\u2019t be billed or shipped on <b>' + esc(fmtLong(no.billingDate)) + '</b>. Your following box carries on as normal \u2014 and you can unskip any time before it ships.</p>',
      confirmLabel: 'Skip this box', confirmClass: 'hhx-btn--navy',
      run: function () { return putAPI('subscription-billing-attempts/skip-order/' + no.id + '?isPrepaid=false&subscriptionContractId=' + cid()); },
      success: 'Box skipped.'
    });
  }
  function doUnskip() {
    var no = nextOrder(); if (!no) return;
    openSheet({
      title: 'Unskip this box?',
      body: '<p class="hhx-sheet-p">We\u2019ll put your <b>' + esc(fmtLong(no.billingDate)) + '</b> box back on the schedule.</p>',
      confirmLabel: 'Unskip box',
      run: function () { return putAPI('subscription-billing-attempts/unskip-order/' + no.id + '?subscriptionContractId=' + cid()); },
      success: 'Box back on the schedule.'
    });
  }
  function doFreq() {
    var c = STATE.f.focus;
    // Weekly plans only \u2014 all are the same discount %, so changing the billing interval
    // directly (the only customer-accessible frequency lever) never changes the price.
    var plans = (STATE.plans || []).filter(function (p) { return p.frequencyInterval === 'WEEK'; });
    if (!plans.length) { toast('Frequencies unavailable right now.'); return; }
    plans.sort(function (a, b) { return a.frequencyCount - b.frequencyCount; });
    var curWeeks = c.interval === 'WEEK' ? c.intervalCount : (c.interval === 'MONTH' ? c.intervalCount * 4 : 0);
    var rows = plans.map(function (p) {
      var isCur = p.frequencyCount === curWeeks;
      var rec = /recommend/i.test(p.frequencyName || '');
      return '<label class="hhx-choice"><input type="radio" name="fq" value="' + p.frequencyCount + '"' + (isCur ? ' checked' : '') + '>' +
        '<span>Every ' + p.frequencyCount + ' weeks' + (p.discountOffer ? ' <em class="hhx-choice-tag">save ' + p.discountOffer + '%</em>' : '') +
        (rec ? ' <em class="hhx-choice-rec">recommended</em>' : '') + (isCur ? ' <em class="hhx-choice-cur">current</em>' : '') + '</span></label>';
    }).join('');
    openSheet({
      title: 'How often?',
      body: '<p class="hhx-sheet-p">Change how often your Grip-X arrives. Your price per box and volume discount stay the same.</p><div class="hhx-choices">' + rows + '</div>',
      confirmLabel: 'Update frequency',
      collect: function (sheet) {
        var sel = sheet.querySelector('input[name="fq"]:checked'); if (!sel) return false;
        return sel.value;
      },
      run: function (weeks) { return putAPI('subscription-contracts-update-billing-interval?contractId=' + cid() + '&interval=WEEK&intervalCount=' + encodeURIComponent(weeks)); },
      success: 'Delivery frequency updated.'
    });
  }
  function doPause() {
    openSheet({
      title: 'Pause deliveries?',
      body: '<p class="hhx-sheet-p">We\u2019ll stop billing and shipping until you resume \u2014 nothing is cancelled, and your price is held. Resume any time from here.</p>',
      confirmLabel: 'Pause deliveries', confirmClass: 'hhx-btn--navy',
      run: function () { return putAPI('subscription-contracts-update-status?contractId=' + cid() + '&status=PAUSED&isExternal=true'); },
      success: 'Deliveries paused.'
    });
  }
  function doResume() {
    openSheet({
      title: 'Resume deliveries?',
      body: '<p class="hhx-sheet-p">Your Grip-X goes back on Set &amp; Forget at your saved frequency and price.</p>',
      confirmLabel: 'Resume deliveries',
      run: function () { return putAPI('subscription-contracts-update-status?contractId=' + cid() + '&status=ACTIVE&isExternal=true'); },
      success: 'You\u2019re back on Set & Forget.'
    });
  }
  function doSendNow() {
    var c = STATE.f.focus, no = nextOrder(); if (!c || !no) return;
    openSheet({
      title: 'Send your next box now?',
      body: '<div class="hhx-alert hhx-alert--amber" style="margin:0 0 12px">This charges <b>' + money(c.total, c.cc) + '</b> to your ' + esc(paymentLabel(c.payment)) +
        ' now and ships straight away.</div><p class="hhx-sheet-p">Your following box will reschedule to keep the same gap. Only do this if you\u2019re running low.</p>',
      confirmLabel: 'Charge & send now', confirmClass: 'hhx-btn--warn',
      run: function () {
        var now = new Date().toISOString().replace(/\.\d{3}Z$/, 'Z');
        return putAPI('subscription-billing-attempts/reschedule-order/' + no.id + '?billingDate=' + encodeURIComponent(now) + '&rescheduleFutureOrder=true');
      },
      success: 'On its way \u2014 your box is being processed.'
    });
  }

  CTX.act = { delay: doDelay, skip: doSkip, unskip: doUnskip, freq: doFreq, pause: doPause, resume: doResume, sendnow: doSendNow };
  /* shared with hh-crew-extras.js (Increment 3) */
  CTX.openSheet = openSheet; CTX.closeSheet = closeSheet; CTX.toast = toast;
})();
